/**
 * The Assortment and Demand strategy answers, which size off the baseline: while a plan has a new
 * variant without one, they neither apply nor save.
 */
const BASELINE_GATED_QUESTIONS: ReadonlySet<string> = new Set(["cannibalization", "seasonTrend"])

export const isBaselineGatedQuestion = (question: string): boolean =>
  BASELINE_GATED_QUESTIONS.has(question)

export const STRATEGY_ON_HOLD_NOTE = "On hold until every variant has a baseline."

export const UNMATCHED_STRATEGY_REASON =
  "Some variants have no baseline yet. Match them before setting strategy."
